import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Row, theme, Typography } from 'antd';

export const TypographyShowHide = ({
  content,
  characterLength = 12,
  width = 120,
}: {
  content: string;
  characterLength?: number;
  width?: number;
}) => {
  const { t } = useTranslation();
  const [showText, setShowText] = useState(false);
  const { token } = theme.useToken();

  const hasLongContent = content.length > characterLength;

  return (
    <>
      <Row style={{ width }}>
        <Typography.Paragraph
          ellipsis={{
            rows: 1,
            expanded: showText,
          }}
          style={{ marginBottom: hasLongContent ? token.marginXS : 0 }}
        >
          {content}
        </Typography.Paragraph>
      </Row>
      {hasLongContent && (
        <Row>
          <Button
            icon={
              <FontAwesomeIcon icon={showText ? faChevronUp : faChevronDown} />
            }
            onClick={() => setShowText(!showText)}
            size="small"
            style={{ marginBottom: token.marginXS }}
          >
            {showText
              ? t('common.buttons.showLess')
              : t('common.buttons.showMore')}
          </Button>
        </Row>
      )}
    </>
  );
};
